import type { AsyncDataOptions, NuxtApp } from '#app'

type UseFetchDataOptions<T> = AsyncDataOptions<T> & {
  key?: string
  withoutCache?: boolean
}

/**
 Кастомный хук обертка над useAsyncData.
 Нужен для более удобного управления переменной isBot,
 в зависимости от которой запросы выполняются на сервере/клиенте.
*/
export const useFetchData = <T>(
  handler: (nuxtApp?: NuxtApp) => Promise<T>,
  options: UseFetchDataOptions<T> = {},
) => {
  const { ssrContext } = useNuxtApp()

  const { key, ...asyncOptions } = options
  const dataKey = key ?? handler.name

  /* Проверяем, есть ли закешированные данные */
  const cached = useNuxtData<T>(dataKey)

  if (cached.data?.value && !options?.withoutCache) {
    return {
      data: cached.data,
      pending: ref(false),
      error: ref(null),
      status: ref<'success'>('success'),
    }
  }

  const isBot = Boolean(ssrContext?.isBot)

  return useAsyncData<T>(dataKey, handler, {
    server: isBot,
    ...asyncOptions,
  })
}
